import React, { useEffect, useState, useRef } from "react";

import { auth, firebase } from "../../Firebase/config";

import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
  arrayRemove,
} from "@firebase/firestore";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import "../Messages.css";
import { all } from "axios";

export default function Phonelessstudents({
  currentclass,
  activename,
  setSelectedclass,
  activeid,
  selectedclass,
  currentstudent,
  setCurrentstudent,
  studentidd,
  parentlanguagecode,
  id2,
  classidd,
  additionallinklevel,
  setShowcurrentroster,
  setShowcurrentpasses,
  getschoolid,
  school,
  town,
  state,
  userdata2,
  editparentcontactinfo,
  setEditparentcontactinfo,
  showcurrentroster,
  drinkwater,
  broom,
  otherpass,
  currentlocation,
  teacherid,
  teacheridforreturn,
  teacher,
  coursename,
  activeid2,
  linkedclass,
  location2,
  selectedStudents,
  setSelectedStudents,
  setCurrentclass,  
  activestudentlist2
}) {
  const [lasttwomonths, setlasttwomonths] = useState([]);

  const [searchingstate, setSearchingstate] = useState(false);
  const [aallpasses, setAallpasses] = useState();

  const [filteredstates, setFilteredstates] = useState([]);
  const [filteredstates2, setFilteredstates2] = useState([]);

  const [activpasses, setActivpasses] = useState([]);
  const [update, setUpdate] = useState();

  const [changehasbeenmade, setChangehasbeenmade] = useState();
  const [endtime, setEndtime] = useState();
  const [begintime, setBegintime] = useState();

  const [revise, setRevise] = useState();

  const [passesbetween, setPassesbetween] = useState();

  const [currentclass2, setCurrentclass2] = useState();

  const [website, setWebsite] = useState();
  const [whatparentssee, setWhatpareentseee] = useState();


  const [phonenumberbefore2, setPhonenumberbefore2] = useState("");

  const [parentemail, setParentemail] = useState("");

  const [visibleStudents, setVisibleStudents] = useState([]);

  const [selectedStudentAnimating, setSelectedStudentAnimating] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [showParentPreviewModal, setShowParentPreviewModal] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const [parentlanguage, setParentlanguage] = useState("");

    const [studentlanguage, setStudentlanguage] = useState("");

  const [newparentlanguage, setNewparentlanguage] = useState("");
  const [language2, setLanguage2] = useState("");
  const [languagecode2, setLanguagecode2] = useState("");
  const [parentlanguagecode2, setParentlanguagecode2] = useState("");

   const [newstudentlanguage, setNewstudentlanguage] = useState("");

  const [day, setDay] = useState();
  const [leftclass, setLeftclass] = useState();

  const [parentlanguage2, setParentlanguage2] = useState("");
  const [pnumber, setPnumber] = useState("");

  const [leavetimeGlobal, setLeavetimeGlobal] = useState();
  const [rightnow, setRightnow] = useState();
  const [whenpassbegan, setWhenpassbegan] = useState();
  const [allottedtime, setAllottedtime] = useState();
  const [currentdate, setCurrentdate] = useState("");
  const [realtimeleave, setRealtimeleave] = useState("");
  const [realtimereturn, setRealtimereturn] = useState("");


  const [destination, setDestination] = useState("");
  const [passexists, setPassexists] = useState("");
  const [passid, setPassid] = useState("");
  const [completed, setCompleted] = useState(false);
  const [passismade, setPassismade] = useState(false);
  const [expectedreturn, setExpectedreturn] = useState();
  const [iamenrolled2, setIamenrolled2] = useState(false);
  const [lengthofclasssession, setLengthofclasssession] = useState(60);

  const [notificationid, setNotificationid] = useState();
  const [gotteachernotificationid, setGotteachernotificationid] = useState();

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");

    const [studentemail, setStudentemail] = useState();
    const [parentemail2,  setParentemail2] = useState();



  const { only2studentid, studentid, classid, language, id } =
    useParams();

  const navigate = useNavigate();

  const justPasted = React.useRef(false);

  const onChanged2 = (text) => {
    if (justPasted.current) {
      justPasted.current = false;
      return;
    }
    setPhonenumberbefore2(text.replace(/[^0-9]/g, ""));
  };

  const answers3 = [
    {
      value: "English",
      code: "en",
    },
    {
      value: "Spanish",
      code: "es",
    },
    {
      value: "Portuguese",
      code: "pt",
    },

    {
      value: "Afrikaans",
      code: "af",
    },
    {
      value: "Albanian",
      code: "sq",
    },
    {
      value: "Amharic",
      code: "am",
    },
    {
      value: "Arabic",
      code: "ar",
    },
    {
      value: "Armenian",
      code: "hy",
    },
    {
      value: "Azerbaijani",
      code: "az",
    },
    {
      value: "Basque",
      code: "eu",
    },
    {
      value: "Belarusian",
      code: "be",
    },
    {
      value: "Bengali",
      code: "bn",
    },
    {
      value: "Bosnian",
      code: "bs",
    },
    {
      value: "Bulgarian",
      code: "bg",
    },
    {
      value: "Catalan",
      code: "ca",
    },
    {
      value: "Cebuano",
      code: "ceb",
    },
    {
      value: "Chinese (Simplified)",
      code: "zh-CN",
    },
    {
      value: "Chinese (Traditional)",
      code: "zh-TW",
    },
    {
      value: "Corsican",
      code: "co",
    },
    {
      value: "Croatian",
      code: "hr",
    },
    {
      value: "Czech",
      code: "cs",
    },
    {
      value: "Danish",
      code: "da",
    },
    {
      value: "Dutch",
      code: "nl",
    },
    {
      value: "Esperanto",
      code: "eo",
    },
    {
      value: "Estonian",
      code: "et",
    },
    {
      value: "Finnish",
      code: "fi",
    },
    {
      value: "French",
      code: "fr",
    },
    {
      value: "Frisian",
      code: "fy",
    },
    {
      value: "Galician",
      code: "gl",
    },
    {
      value: "Georgian",
      code: "ka",
    },
    {
      value: "German",
      code: "de",
    },
    {
      value: "Greek",
      code: "el",
    },
    {
      value: "Gujarati",
      code: "gu",
    },
    {
      value: "Haitian Creole",
      code: "ht",
    },
    {
      value: "Hausa",
      code: "ha",
    },
    {
      value: "Hawaiian",
      code: "haw",
    },
    {
      value: "Hebrew",
      code: "iw",
    },
    {
      value: "Hindi",
      code: "hi",
    },
    {
      value: "Hmong",
      code: "hmn",
    },
    {
      value: "Hungarian",
      code: "hu",
    },
    {
      value: "Icelandic",
      code: "is",
    },
    {
      value: "Igbo",
      code: "ig",
    },
    {
      value: "Indonesian",
      code: "id",
    },
    {
      value: "Irish",
      code: "ga",
    },
    {
      value: "Italian",
      code: "it",
    },
    {
      value: "Japanese",
      code: "ja",
    },
    {
      value: "Javanese",
      code: "jw",
    },
    {
      value: "Kannada",
      code: "kn",
    },
    {
      value: "Kazakh",
      code: "kk",
    },
    {
      value: "Khmer",
      code: "km",
    },
    {
      value: "Korean",
      code: "ko",
    },
    {
      value: "Kurdish",
      code: "ku",
    },
    {
      value: "Kyrgyz",
      code: "ky",
    },
    {
      value: "Lao",
      code: "lo",
    },
    {
      value: "Latin",
      code: "la",
    },
    {
      value: "Latvian",
      code: "lv",
    },
    {
      value: "Lithuanian",
      code: "lt",
    },
    {
      value: "Luxembourgish",
      code: "lb",
    },
    {
      value: "Macedonian",
      code: "mk",
    },
    {
      value: "Malagasy",
      code: "mg",
    },
    {
      value: "Malay",
      code: "ms",
    },
    {
      value: "Malayalam",
      code: "ml",
    },
    {
      value: "Maltese",
      code: "mt",
    },
    {
      value: "Maori",
      code: "mi",
    },
    {
      value: "Marathi",
      code: "mr",
    },
    {
      value: "Mongolian",
      code: "mn",
    },
    {
      value: "Myanmar (Burmese)",
      code: "my",
    },
    {
      value: "Nepali",
      code: "ne",
    },
    {
      value: "Norwegian",
      code: "no",
    },
    {
      value: "Nyanja (Chichewa)",
      code: "ny",
    },
    {
      value: "Pashto",
      code: "ps",
    },
    {
      value: "Persian",
      code: "fa",
    },
    {
      value: "Polish",
      code: "pl",
    },

    {
      value: "Punjabi",
      code: "pa",
    },
    {
      value: "Romanian",
      code: "ro",
    },
    {
      value: "Russian",
      code: "ru",
    },
    {
      value: "Samoan",
      code: "sm",
    },
    {
      value: "Scots Gaelic",
      code: "gd",
    },
    {
      value: "Serbian",
      code: "sr",
    },
    {
      value: "Sesotho",
      code: "st",
    },
    {
      value: "Shona",
      code: "sn",
    },
    {
      value: "Sindhi",
      code: "sd",
    },
    {
      value: "Sinhala (Sinhalese)",
      code: "si",
    },
    {
      value: "Slovak",
      code: "sk",
    },
    {
      value: "Slovenian",
      code: "sl",
    },
    {
      value: "Somali",
      code: "so",
    },
    {
      value: "Sundanese",
      code: "su",
    },
    {
      value: "Swahili",
      code: "sw",
    },
    {
      value: "Swedish",
      code: "sv",
    },
    {
      value: "Tagalog (Filipino)",
      code: "tl",
    },
    {
      value: "Tajik",
      code: "tg",
    },
    {
      value: "Tamil",
      code: "ta",
    },
    {
      value: "Telugu",
      code: "te",
    },
    {
      value: "Thai",
      code: "th",
    },
    {
      value: "Turkish",
      code: "tr",
    },
    {
      value: "Ukrainian",
      code: "uk",
    },
    {
      value: "Urdu",
      code: "ur",
    },
    {
      value: "Uzbek",
      code: "uz",
    },
    {
      value: "Vietnamese",
      code: "vi",
    },
    {
      value: "Welsh",
      code: "cy",
    },
    {
      value: "Xhosa",
      code: "xh",
    },
    {
      value: "Yiddish",
      code: "yi",
    },
    {
      value: "Yoruba",
      code: "yo",
    },
    {
      value: "Zulu",
      code: "zu",
    },
    { value: "Not Listed" },
  ];

  useEffect(() => {
    if (typeof newparentlanguage != "undefined") {
      textsearchedstates(newparentlanguage);
    }
  }, [newparentlanguage]);

    useEffect(() => {
    if (typeof newstudentlanguage != "undefined") {
      textsearchedstates2(newstudentlanguage);
    }
  }, [newstudentlanguage]);

  const textsearchedstates = () => {
    setSearchingstate(true);

    console.log("an array of states1");
    let postss = [];
    for (let i in answers3) {
      let match = false;
      let postt = answers3[i];

      for (let prop in postt) {
        let lower = JSON.stringify(postt[prop]).toLowerCase();
        if (lower.startsWith(newparentlanguage.toString().toLowerCase(), 1)) {
          match = true;
        }
      }
      if (match == true) {
        if (!postss.includes(postt.id)) {
          postss.push(postt)
        }
      }
    }
    setFilteredstates(postss);
  };

  const textsearchedstates2 = () => {
    setSearchingstate(true);

    console.log("an array of states1");
    let postss = [];
    for (let i in answers3) {
      let match = false;
      let postt = answers3[i];

      for (let prop in postt) {
        let lower = JSON.stringify(postt[prop]).toLowerCase();
        if (lower.startsWith(newstudentlanguage.toString().toLowerCase(), 1)) {
          match = true;
        }
      }
      if (match == true) {
        if (!postss.includes(postt.id)) {
          postss.push(postt)
        }
      }
    }
    setFilteredstates2(postss);
  };





  const deletethisphonenumber = (phoneNumber) => {
    if (!currentstudent || !currentstudent.id) {
      console.error("No student selected");
      return;
    }

    // Update Firebase
    updateDoc(doc(firebase, "users", currentstudent.id), {
      parentphonenumber: arrayRemove(phoneNumber)
    })
      .then(() => {
        console.log("Phone number deleted successfully");

        // Update local state
        const updatedStudent = { ...currentstudent };
        updatedStudent.parentphonenumber = updatedStudent.parentphonenumber.filter(
          phone => phone !== phoneNumber
        );
        setCurrentstudent(updatedStudent);

        if (Array.isArray(currentclass) && updatedStudent && updatedStudent.id) {
          const updatedClass = currentclass.map(student =>
            student.id === updatedStudent.id ? updatedStudent : student
          );
          setCurrentclass(updatedClass);
        }
      })
      .catch((error) => {
        console.error("Error deleting phone number:", error);
        alert("Failed to delete phone number: " + error.message);
      });
  }

  useEffect(() => {
    setSelectedStudents([]);
  }, [activeid]);

  const deletethisemail = (email) => {

    if (!currentstudent || !currentstudent.id) {
      console.error("No student selected");
      return;
    }

    // Update Firebase
    updateDoc(doc(firebase, "users", currentstudent.id), {
      parentemail: arrayRemove(email)
    })
      .then(() => {
        console.log("Email deleted successfully");

        // Update local state
        const updatedStudent = { ...currentstudent };
        updatedStudent.parentemail = updatedStudent.parentemail.filter(
          e => e !== email
        );
        setCurrentstudent(updatedStudent);

        if (Array.isArray(currentclass) && updatedStudent && updatedStudent.id) {
          const updatedClass = currentclass.map(student =>
            student.id === updatedStudent.id ? updatedStudent : student
          );
          setCurrentclass(updatedClass);
        }

        const classIds = Array.isArray(updatedStudent.classlist) && updatedStudent.classlist.length
          ? updatedStudent.classlist
          : (typeof classidd !== "undefined" && classidd ? [classidd] : []);

        if (classIds.length > 0) {
          const parentEmailsArray = Array.isArray(updatedStudent.parentemail)
            ? updatedStudent.parentemail
            : (updatedStudent.parentemail ? [updatedStudent.parentemail] : []);
          Promise.all(classIds.map(cid =>
            updateClassStudentEntry(
              cid,
              { id: updatedStudent.id, email: updatedStudent.email || "" },
              parentEmailsArray,
              updatedStudent.parentlanguagecode || parentlanguagecode2 || ""
            )
          )).catch(err => {
            console.error("Error syncing class studentIds after email delete:", err);
          });
        }
      })
      .catch((error) => {
        console.error("Error deleting email:", error);
        alert("Failed to delete email: " + error.message);
      });
  }

  const handlePaste2 = (event) => {
    event.preventDefault(); // Prevent default paste behavior
    const clipboardData = event.clipboardData || window.Clipboard;
    const pastedText = clipboardData.getData("text");

    // Remove unwanted elements from the pasted text
    const cleanedText1 = pastedText.replace(/-/g, "");
    const cleanedText2 = cleanedText1.replace(/\(/g, "");
    const cleanedText3 = cleanedText2.replace(/\)/g, "");
    const cleanedText4 = cleanedText3.replace(/\s/g, "");

    setPhonenumberbefore2(cleanedText4);
    event.target.value = cleanedText4; // Ensure input value is in sync with state
    justPasted.current = true;
  };


  const makingpassbefore = () => {

    // Create a modal overlay
    const modal = document.createElement("div");
    modal.style.position = "fixed";
    modal.style.top = 0;
    modal.style.left = 0;
    modal.style.width = "100vw";
    modal.style.height = "100vh";
    modal.style.background = "rgba(0,0,0,0.5)";
    modal.style.display = "flex";
    modal.style.alignItems = "center";
    modal.style.justifyContent = "center";
    modal.style.opacity = .95
    modal.style.zIndex = 9999;

    // Modal content
    const content = document.createElement("div");
    content.style.background = "#000";
    content.style.padding = "32px 24px";
    content.style.borderRadius = "12px";
    content.style.boxShadow = "0 4px 24px rgba(0,0,0,0.15)";
    content.style.textAlign = "center";
    content.style.minWidth = "260px";
    content.style.maxWidth = "90vw";

    const title = document.createElement("div");
    title.textContent = "Select Pass Destination";
    title.style.fontSize = "1.2rem";
    title.style.fontWeight = "bold";
    title.style.marginBottom = "20px";
    title.style.color = "white";
    content.appendChild(title);

    const destinations = [
      { label: "Bathroom", value: "Bathroom" },
      { label: "Get Drink of Water", value: "Drink of Water" },
      { label: "Nurse", value: "Nurse" },
      { label: "Other", value: "Other" }
    ];

    destinations.forEach(dest => {
      const btn = document.createElement("button");
      btn.textContent = dest.label;
      btn.style.margin = "8px";
      btn.style.padding = "10px 18px";
      btn.style.fontSize = "18px";
      btn.style.width = "90%";
      btn.style.borderRadius = "6px";
      btn.style.display = "block"
      btn.style.marginLeft = "auto";
      btn.style.marginRight = "auto";
      btn.style.border = "4px solid #e43522";
      btn.style.background = "#013469";
      btn.style.color = "#fff";
      btn.style.cursor = "pointer";
      btn.onmouseover = () => btn.style.background = "#0256a6";
      btn.onmouseout = () => btn.style.background = "#013469";
      btn.onclick = () => {
        setDestination(dest.value);
        document.body.removeChild(modal);
      };
      content.appendChild(btn);
    });

    // Optional: Add a cancel button
    const cancelBtn = document.createElement("button");
    cancelBtn.textContent = "Cancel";
    cancelBtn.style.margin = "8px";
    cancelBtn.style.padding = "10px 18px";
    cancelBtn.style.fontSize = "1rem";
    cancelBtn.style.borderRadius = "6px";
    cancelBtn.style.border = "none";
    cancelBtn.style.background = "#ccc";
    cancelBtn.style.color = "#333";
    cancelBtn.style.cursor = "pointer";
    cancelBtn.onclick = () => {
      document.body.removeChild(modal);
    };
    content.appendChild(document.createElement("br"));
    content.appendChild(cancelBtn);

    modal.appendChild(content);
    document.body.appendChild(modal);
  }

  const makingpass = () => {
    console.log("Pass started")
    var r = new Date();
    var s = Date.now();

    setRightnow(s);
    setLeavetimeGlobal(r);
    setLeftclass(s);
    setWhenpassbegan(s);
  };

  useEffect(() => {
    if (leavetimeGlobal) {
      console.log("Pass started2", broom, drinkwater, otherpass, allottedtime);
      const formatAMPM = () => {
        let hours = leavetimeGlobal.getHours();
        let minutes = leavetimeGlobal.getMinutes();
        let ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes.toString().padStart(2, "0");
        let strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
      };

      const p = formatAMPM(leavetimeGlobal);

      setRealtimeleave(p);
      setCurrentdate(
        leavetimeGlobal.getMonth() +
        1 +
        "/" +
        leavetimeGlobal.getDate() +
        "/" +
        leavetimeGlobal.getFullYear()
      );
      console.log("Pass started3", typeof allottedtime);

      if (typeof allottedtime === "number" && allottedtime > 0) {
        // Calculate expected return time by adding allottedtime (in minutes) to leavetimeGlobal
        const expectedReturn = new Date(leavetimeGlobal.getTime() + allottedtime * 60000);
        const formatAMPM = (date) => {
          let hours = date.getHours();
          let minutes = date.getMinutes();
          let ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12;
          hours = hours ? hours : 12;
          minutes = minutes.toString().padStart(2, "0");
          return hours + ":" + minutes + " " + ampm;
        };
        setRealtimereturn(formatAMPM(expectedReturn));
      } else {
        setRealtimereturn("");
      }
    }

  }, [leavetimeGlobal]);


  useEffect(() => {

    if (destination != "") {
      if (destination == "Bathroom") {
        setAllottedtime(broom);
      } else if (destination == "Drink of Water") {
        setAllottedtime(drinkwater);
      } else {
        setAllottedtime(otherpass);
      }


    }
  }, [destination]);


  useEffect(() => {

    if (typeof allottedtime != "undefined") {

      makingpass();
    }
  }, [allottedtime]);

  useEffect(() => {

    if (currentdate != "" && realtimeleave != "" && realtimereturn != "") {
      console.log("Pass started16");
      finalizehallpass();
    }
  }, [currentdate && realtimeleave && realtimereturn]);

  async function finalizehallpass() {
    console.log("finalizehallpass called with allottedtime:", allottedtime, "passexists:", passexists);
    if (allottedtime > 0 && passexists == "") {
      console.log("Pass started5")
      const nowww = Date.now();
      const expected = nowww + (allottedtime * 60000);
      const nowwwwwww = Date.now();

      // Get photoUrl from activestudentlist2
      let studentPhotoUrl = "";
      if (Array.isArray(activestudentlist2) && currentstudent?.id) {
        const matchingStudent = activestudentlist2.find(student => student.id === currentstudent.id);
        studentPhotoUrl = matchingStudent?.photoUrl ? matchingStudent.photoUrl : "";
      }

      if (typeof getschoolid != "undefined") {
        await updateDoc(doc(firebase, "schools", getschoolid), {
          update: nowwwwwww,
        }).catch((error) => {
          console.log(error);
          alert(error);
        });
      }

      try {

        const docRef = await addDoc(collection(firebase, "passes"), {
          dateofpass: currentdate ? currentdate : "",
          expectedtimeofarrival: realtimereturn ? realtimereturn : "",
          timepassinitiated: nowww,
          timeallowedonpass: allottedtime ? allottedtime : "",
          linkedclass: linkedclass ? linkedclass : "",
          language: language2 ? language2 : "",
          parentlanguage: parentlanguage2 ? parentlanguage2 : "",
          languagecode: languagecode2 ? languagecode2 : "",
          parentlanguagecode: parentlanguagecode2 ? parentlanguagecode2 : "",
          firstname: firstname ? firstname : "",
          lastname: lastname ? lastname : "",
          classid: activeid ? activeid : "",
          coursename: coursename ? coursename : "",
          comingfrom: location2 ? location2 : "",
          teacherid: teacherid ? teacherid : "",
          notificationid: typeof notificationid != "undefined" ? notificationid : 0,
          teachernotificationid: typeof gotteachernotificationid != "undefined" ? gotteachernotificationid : 0,
          returnteacherid: teacheridforreturn ? teacheridforreturn : "",
          classesinvolved: activeid ? [activeid] : [],
          teachersinvolved: teacherid ? [teacherid] : [],

          studentid: currentstudent?.id ? currentstudent.id : "",
          school: school ? school : "",
          town: town ? town : "",
          state: state ? state : "",
          teacheriscalled: teacher ? teacher : "",
          destination: destination ? destination : "",
          timeleftclass: realtimeleave ? realtimeleave : "",
          leftclass: nowww,
          returned: 0,
          timereturned: 0,
          whenlimitwillbereached: 0,
          // returnedbeforetimelimit: "null",
          differenceoverorunderinminutes: 0,

          phonenumber: Array.isArray(pnumber) ? pnumber : pnumber ? [pnumber] : [],
          studentisenrolled: typeof iamenrolled2 != "undefined" ? iamenrolled2 : "",
          lengthofclasssession: lengthofclasssession > 0 ? lengthofclasssession : 60,
          studentPhotoUrl: studentPhotoUrl ? studentPhotoUrl : "",
          studentemail: studentemail ? studentemail : "",
          parentemail: parentemail2 ? parentemail2 : "",

        }).then(async (userRec) => {

          console.log("2", "THIS HAPpened");

          setPassid(userRec.id);
          let user = userRec.id;
          await updateDoc(doc(firebase, "passes", user), {
            id: user,
            leftclass: nowww,
            timeleftclass: leavetimeGlobal.toLocaleTimeString([], {
              hour12: true,
              timeStyle: "short",
            }),
            whenlimitwillbereached: expected,
            passdetailrightnow: nowww,
            passdetailcurrentdate: currentdate,
            passdetailrealtimeleave: realtimeleave,
          }).catch((error) => {
            console.log(error); alert(error);
          });

          await updateDoc(doc(firebase, "users", teacherid), {
            addingnumber: nowww,
            idofstudent: id,
            passnumber: userRec.id,
          }).catch((error) => {
            console.log(error); alert(error);
          });

          await updateDoc(doc(firebase, "users", currentstudent.id), {
            status: "On Pass",
            passid: userRec.id
          }).catch((error) => {
            console.log(error); alert(error);
          });

          setPassexists(userRec.id);


          // Create the new pass object with same properties as in Firestore
          const newPass = {
            id: user,
            dateofpass: currentdate,
            expectedtimeofarrival: realtimereturn,
            timepassinitiated: nowww,
            timeallowedonpass: allottedtime,
            linkedclass: linkedclass ? linkedclass : "",
            language: language2,
            parentlanguage: parentlanguage2,
            languagecode: languagecode2,
            parentlanguagecode: parentlanguagecode2,
            firstname: firstname,
            lastname: lastname,
            classid: activeid,
            coursename: coursename,
            comingfrom: location2,
            teacherid: teacherid,
            notificationid: typeof notificationid != "undefined" ? notificationid : 0,
            teachernotificationid: typeof gotteachernotificationid != "undefined" ? gotteachernotificationid : 0,
            returnteacherid: teacheridforreturn,
            classesinvolved: [activeid],
            teachersinvolved: [teacherid],
            studentid: currentstudent.id,
            school: school,
            town: town,
            state: state,
            teacheriscalled: teacher,
            destination: destination,
            timeleftclass: realtimeleave,
            leftclass: nowww,
            whenlimitwillbereached: expected,
            passdetailrightnow: nowww,
            passdetailcurrentdate: currentdate,
            passdetailrealtimeleave: realtimeleave,
            returned: 0,
            timereturned: 0,
            differenceoverorunderinminutes: 0,
            phonenumber: Array.isArray(pnumber) ? pnumber : [pnumber],
            studentisenrolled: iamenrolled2,
            lengthofclasssession: lengthofclasssession > 0 ? lengthofclasssession : 60,
          };
        })

      } catch (error) {
        console.log("adding doc errof", error); alert(error);
      }

      // .catch((error) => {
      //   console.log(error); alert(error);
      // })
      setExpectedreturn(nowww + (allottedtime * 60000));
      setCompleted(true);
      setPassismade(true);
      setCurrentstudent("");
      setShowcurrentpasses(true)
    } else {
      console.log("Condition failed: allottedtime > 0:", allottedtime > 0, "passexists == '':", passexists == "");
    }
  }


  const deduplicateArray = arr => Array.from(new Set(arr.filter(Boolean)));

  const setSaveparentcontactinfo = (student) => {
    // Track if we need to update anything
    const updates = {};
    let needsUpdate = false;

    if (phonenumberbefore2.length === 10) {
      updates.parentphonenumber = arrayUnion(phonenumberbefore2);
      needsUpdate = true;
    }

    if (parentemail.includes('@') && parentemail.includes('.')) {
      updates.parentemail = arrayUnion(parentemail);
      needsUpdate = true;
    }

    // Always set parentcontacteditconfirmed to true when this function is called
    updates.parentcontacteditconfirmed = true;
    needsUpdate = true;

    if (needsUpdate) {
      // Update Firebase first
      updateDoc(doc(firebase, "users", student.id), updates)
        .then(() => getDoc(doc(firebase, "users", student.id)))
        .then(async (docSnap) => {
          if (docSnap.exists()) {
            const fresh = { id: student.id, ...docSnap.data() };
            fresh.parentphonenumber = deduplicateArray(fresh.parentphonenumber || []);
            fresh.parentemail = deduplicateArray(fresh.parentemail || []);

            setCurrentstudent(fresh);

            setCurrentclass(prev =>
              Array.isArray(prev)
                ? prev.map(s => s.id === student.id ? fresh : s)
                : prev
            );

              // Determine class IDs to update: prefer student's classlist, fallback to prop classidd
              const classIds = Array.isArray(fresh.classlist) && fresh.classlist.length
                ? fresh.classlist
                : (typeof classidd !== "undefined" && classidd ? [classidd] : []);

              // Update classesbeingtaught.studentIds entries for each class using authoritative fresh.parentemail array
              if (classIds.length > 0) {
                const parentEmailsArray = Array.isArray(fresh.parentemail)
                  ? fresh.parentemail
                  : (fresh.parentemail ? [fresh.parentemail] : []);
                await Promise.all(classIds.map(cid =>
                  updateClassStudentEntry(
                    cid,
                    { id: student.id, email: fresh.email || student.email || "" },
                    parentEmailsArray,
                    fresh.parentlanguagecode || parentlanguagecode2 || ""
                  )
                ));
              }
          }
        })
        .catch((error) => {
          console.error("Error updating contact info:", error);
          alert(error);
        });

      // Reset input fields after update initiated
      if (phonenumberbefore2.length === 10) {
        setPhonenumberbefore2('');
      }
      if (parentemail.includes('@') && parentemail.includes('.')) {
        setParentemail('');
      }
    }
  };

  const markParentContactConfirmed = (studentId) => {
    // Validation checks
    if (!studentId || typeof studentId !== 'string' || studentId.trim() === '') {
      console.error("Invalid studentId: studentId is required and must be a non-empty string");
      return;
    }

    if (studentId.length < 3) {
      console.error("Invalid studentId: studentId is too short (minimum 3 characters)");
      return;
    }

    // Proceed with Firebase update
    updateDoc(doc(firebase, "users", studentId), {
      parentcontacteditconfirmed: true
    })
      .then(() => {
        console.log("Successfully marked parent contact as confirmed for student:", studentId);
      })
      .catch((error) => {
        console.error("Error marking parent contact as confirmed:", error);
      });
  };
  const handleSelect = (value, i) => {
    console.log("this is the language", value);

    updateDoc(doc(firebase, "users", currentstudent.id), {
      parentlanguage: value.value ? value.value : "English",
      parentlanguagecode: value.code ? value.code : "en"
    })
      .then(async () => {
        console.log("Phone language updated successfully");

        // Update local state
        const updatedStudent = { ...currentstudent };
        updatedStudent.parentlanguage = value.value;
        updatedStudent.parentlanguagecode = value.code;
        setCurrentstudent(updatedStudent);

        if (Array.isArray(currentclass) && updatedStudent && updatedStudent.id) {
          const updatedClass = currentclass.map(student =>
            student.id === updatedStudent.id ? updatedStudent : student
          );
          setCurrentclass(updatedClass);
        }

        // Update classesbeingtaught.studentIds for classes this student belongs to
        const classIds = Array.isArray(updatedStudent.classlist) && updatedStudent.classlist.length
          ? updatedStudent.classlist
          : (typeof classidd !== "undefined" && classidd ? [classidd] : []);

        if (classIds.length > 0) {
          await Promise.all(classIds.map(cid =>
            updateClassStudentEntry(
              cid,
              { id: updatedStudent.id, email: updatedStudent.email || "" },
              null,
              value.code
            )
          ));
        }
      })
      .catch((error) => {
        console.error("Error updating parent language:", error);
        alert("Failed to update parent language: " + error.message);
      });
  }

  const handleStudentLanguageSelect = (value, i) => {
    console.log("this is the student language", value);

    updateDoc(doc(firebase, "users", currentstudent.id), {
      language: value.value ? value.value : "English",
      languagecode: value.code ? value.code : "en"
    })
      .then(async () => {
        console.log("Student language updated successfully");

        // Update local state
        const updatedStudent = { ...currentstudent };
        updatedStudent.language = value.value;
        updatedStudent.languagecode = value.code;
        setCurrentstudent(updatedStudent);

        if (Array.isArray(currentclass) && updatedStudent && updatedStudent.id) {
          const updatedClass = currentclass.map(student =>
            student.id === updatedStudent.id ? updatedStudent : student
          );
          setCurrentclass(updatedClass);
        }

        // Update classesbeingtaught.studentIds for classes this student belongs to
        const classIds = Array.isArray(updatedStudent.classlist) && updatedStudent.classlist.length
          ? updatedStudent.classlist
          : (typeof classidd !== "undefined" && classidd ? [classidd] : []);

        if (classIds.length > 0) {
          await Promise.all(classIds.map(cid =>
            updateClassStudentEntry(
              cid,
              { id: updatedStudent.id, email: updatedStudent.email || "" },
              null,
              value.code // pass new language code
            )
          ));
        }
      })
      .catch((error) => {
        console.error("Error updating student language:", error);
        alert("Failed to update student language: " + error.message);
      });
  }

  const selectHandler = (value, i) => {
    if (value && studentidd != value.id) {
      setSelectedStudentAnimating(true);
      setDetailsVisible(false);

      // Set the current student which will update studentidd
      setCurrentstudent(value);

      // After a delay to allow for animation, show the details
      setTimeout(() => {
        setSelectedStudentAnimating(false);
        setDetailsVisible(true);
      }, 500); // Adjust timing as needed
    } else {
      setCurrentstudent("");
      setSelectedStudentAnimating(false);
      setDetailsVisible(false);
    }
  };

  const goToAdjacentStudent = (direction) => {
    if (!Array.isArray(currentclass) || currentclass.length === 0 || !currentstudent?.id) {
      return;
    }

    const currentIndex = currentclass.findIndex(student => student.id === currentstudent.id);
    if (currentIndex === -1) {
      return;
    }

    const nextIndex = direction === "previous"
      ? (currentIndex - 1 + currentclass.length) % currentclass.length
      : (currentIndex + 1) % currentclass.length;

    const nextStudent = currentclass[nextIndex];
    if (nextStudent) {
      setCurrentstudent(nextStudent);
      setSelectedStudentAnimating(false);
      setDetailsVisible(true);
    }
  };

  useEffect(() => {
    if (currentclass && currentclass.length > 0) {
      // Reset visible students when component mounts or currentclass changes
      setVisibleStudents([]);

      // Staggered animation to reveal students one by one
      currentclass.forEach((student, index) => {
        setTimeout(() => {
          setVisibleStudents(prev => [...prev, student.id]);
        }, 100 * index); // 200ms delay between each student (1/5 second)
      });
    }

    // Clean up effect when component unmounts
    return () => {
      setVisibleStudents([]);
    };
  }, [currentclass]);

  useEffect(() => {
    let date = Date.now();
    console.log(activename, "hellooooo");
    setRevise(date);
  }, [activename, activeid]);

  useEffect(() => {
    if (typeof currentstudent != "undefined") {
      console.log(currentstudent, "currentstudentttt");

      // Set student-specific data
      setFirstname(currentstudent.localfirstname || currentstudent.firstname || "");
      setLastname(currentstudent.locallastname || currentstudent.lastname || "");

      // Set language settings
      setLanguage2(currentstudent.language || "English");
      setLanguagecode2(currentstudent.languagecode || "en");
      setParentlanguage2(currentstudent.parentlanguage || "English");
      setParentlanguagecode2(currentstudent.parentlanguagecode || "en");


      setStudentemail(currentstudent.email || "");
      setParentemail2(currentstudent.parentemail || "");

      

      // Set location data

      // Set contact info
      if (Array.isArray(currentstudent.parentphonenumber) && currentstudent.parentphonenumber.length > 0) {
        setPnumber(currentstudent.parentphonenumber);
      } else {
        setPnumber(currentstudent.phonenumber || "");
      }
      setIamenrolled2(true);
      setLengthofclasssession(60); // Default class length in minutes
    }
  }, [currentstudent]);

  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      console.log(selectedclass, "selectedclassss");

      // Set class-specific data
      // setCoursename(selectedclass.classname || "");
      // setActiveid2(selectedclass.key || "");
      // setLinkedclass(selectedclass.key || "");

      // Set teacher data (assuming the current user is the teacher)

      // setTeacherid(id2);
      // setTeacheridforreturn(id2);
      // setTeacher(selectedclass.teacheriscalled || "");

      // Set destination defaults
      // setDestination("Bathroom");

      // Reset pass state for new class selection
      setPassexists("");
      setPassid("");
      setCompleted(false);
      setPassismade(false);

      // Set the day to undefined to trigger finalizehallpass when date is set
      setDay(undefined);
    }
  }, [selectedclass]);

  let webpassword = "";

  useEffect(() => {
    console.log(studentidd, activeid, parentlanguagecode, id2, "all the info")

    if (typeof studentidd != "undefined" && typeof activeid != "undefined" && typeof id2 != "undefined" && typeof parentlanguagecode != "undefined" && typeof classidd != "undefined") {

      if (additionallinklevel < 2) {

        setWebsite("https://fastclasspass.web.app/view/checker/id/" + id2 + "/only2studentid/" +
          studentidd + "/" + classidd +
          "/id/" +
          id2 +
          "/language/" +
          parentlanguagecode);
      } else {
        setWebsite("https://fastclasspass.web.app/view/checker/id/" + id2 + "/studentid/" +
          studentidd + "/" + classidd +
          "/id/" +
          id2 +
          "/language/" +
          parentlanguagecode);
      }
    }

  }, [studentidd, activeid, parentlanguagecode, id2, classidd, additionallinklevel]);

  useEffect(() => {
    if (typeof website != "undefined") {

      console.log(website, "websiteeee")
    }

  }, [website]);


  useEffect(() => {
    console.log(studentidd, activeid, parentlanguagecode, id2, classidd, "all the info")



    if (typeof studentidd != "undefined" && typeof activeid != "undefined" && typeof parentlanguagecode != "undefined" && typeof id2 != "undefined" && typeof classidd != "undefined" && typeof additionallinklevel != "undefined") {
      if (additionallinklevel < 2) {
        setWhatpareentseee("https://fastclasspass.web.app/only2studentid/" +
          studentidd + "/" + classidd +
          "/id/" +
          id2 +
          "/language/" +
          parentlanguagecode);

      } else {
        setWhatpareentseee("https://fastclasspass.web.app/studentid/" +
          studentidd + "/" + classidd +
          "/id/" +
          id2 +
          "/language/" +
          parentlanguagecode);
      }
    }

  }, [studentidd, activeid, parentlanguagecode, id2, classidd, additionallinklevel]);

  useEffect(() => {
    if (typeof whatparentssee != "undefined") {

      console.log(whatparentssee, "website")
    }
  }, [whatparentssee]);

  useEffect(() => {
    console.log("Mapofstudentsdatabase mounted/updated");
    console.log("currentclass:", currentclass);
    console.log("activeid:", activeid);
    console.log("Has required property:",
      currentclass && currentclass[0] && currentclass[0][activeid] !== undefined);
  }, [currentclass, activeid]);


  useEffect(() => {
    if (showcurrentroster) {
      // Reset edit mode when showing roster again
      setEditparentcontactinfo(false);
    }
  }, [showcurrentroster]);

  useEffect(() => {
    if (!currentstudent?.id) {
      setShowParentPreviewModal(false);
    }
  }, [currentstudent]);

  // console.log(
  //   "currentclass:", currentclass,
  //   ", activename:", activename,
  //   ", activeid:", activeid,
  //   ", selectedclass.classname:", selectedclass.classname,
  //   ", currentstudent.localfirstname:", currentstudent.localfirstname,
  //   ", studentidd:", studentidd,
  //   ", parentlanguagecode:", parentlanguagecode,
  //   ", id2:", id2,
  //   ", classidd:", classidd,
  //   ", additionallinklevel:", additionallinklevel,
  //   ", getschoolid:", getschoolid,
  //   ", school:", school,
  //   ", town:", town,
  //   ", state:", state,
  //   ", userdata2:", userdata2,
  //   ", editparentcontactinfo:", editparentcontactinfo,
  //   ", showcurrentroster:", showcurrentroster, "ONLY SHOW THIS"
  // );

  const handleStudentHover = (studentId) => {

    if (typeof studentidd === "undefined" || studentidd === "") {
      setSelectedStudents(prev => {
        if (Array.isArray(prev)) {
          // Remove if exists, add if not
          if (prev.includes(studentId)) {
            return prev.filter(id => id !== studentId);
          } else {
            return [...prev, studentId];
          }
        } else {
          // If prev is not an array, initialize as array
          return [studentId];
        }
      });
    }
  };


  useEffect(() => {
    console.log("Selected students updated:", selectedStudents, currentclass);
  }, [selectedStudents]);


  // Replace the existing updateClassStudentEntry function with this:
  const updateClassStudentEntry = async (classId, studentIdentifier, parentEmails = null, newParentLanguageCode = null) => {
    if (!classId || !studentIdentifier) return;
    try {
      // Accept either id string, email string, or object { id, email }
      let studentIdParam = null;
      let studentEmailParam = null;
      if (typeof studentIdentifier === "string") {
        if (studentIdentifier.includes("@")) studentEmailParam = studentIdentifier.toLowerCase();
        else studentIdParam = studentIdentifier;
      } else if (typeof studentIdentifier === "object" && studentIdentifier !== null) {
        studentIdParam = studentIdentifier.id || studentIdentifier.studentId || studentIdentifier.uid || null;
        studentEmailParam = (studentIdentifier.email || studentIdentifier.emailAddress || "").toString().toLowerCase() || null;
      }

      const classRef = doc(firebase, "classesbeingtaught", classId);
      const classSnap = await getDoc(classRef);
      if (!classSnap.exists()) return;
      const classData = classSnap.data();
      const arr = Array.isArray(classData.studentIds) ? classData.studentIds : [];
      let changed = false;

      const normalizedParentEmails = Array.isArray(parentEmails)
        ? parentEmails.filter(Boolean)
        : (parentEmails === null ? null : (parentEmails ? [parentEmails] : []));

      const newArr = arr.map((item) => {
        if (!item) return item;
        const itemId = (item.firebasestudentid || item.studentId || "").toString();
        const itemEmail = (item.email || "").toString().toLowerCase();

        const matchById = studentIdParam && itemId === studentIdParam.toString();
        const matchByEmail = studentEmailParam && itemEmail === studentEmailParam;

        if (matchById || matchByEmail) {
          changed = true;
          // If called from handleStudentLanguageSelect, update languagecode as well
          return {
            ...item,
            parentemail: normalizedParentEmails !== null
              ? normalizedParentEmails
              : (Array.isArray(item.parentemail) ? item.parentemail : (item.parentemail ? [item.parentemail] : [])),
            parentlanguagecode: newParentLanguageCode || item.parentlanguagecode || "en",
            languagecode: newParentLanguageCode || item.languagecode || "en"
          };
        }
        return item;
      });

      if (changed) {
        await updateDoc(classRef, { studentIds: newArr });
        console.log("Updated classesbeingtaught.studentIds for class:", classId);
        // --- Update local currentclass state if present ---
        if (typeof setCurrentclass === 'function') {
          const studentIdParamStr = studentIdParam ? studentIdParam.toString() : null;
          const studentEmailParamStr = studentEmailParam ? studentEmailParam.toString() : null;
          setCurrentclass(prev => {
            if (!Array.isArray(prev)) return prev;
            return prev.map(student => {
              if ((studentIdParamStr && (student.id === studentIdParamStr)) ||
                  (studentEmailParamStr && (student.email || '').toLowerCase() === studentEmailParamStr)) {
                const updatedEntry = newArr.find(item => {
                  const itemId = (item.firebasestudentid || item.studentId || '').toString();
                  const itemEmail = (item.email || '').toString().toLowerCase();
                  return (studentIdParamStr && itemId === studentIdParamStr) ||
                         (studentEmailParamStr && itemEmail === studentEmailParamStr);
                });
                if (updatedEntry) {
                  return {
                    ...student,
                    parentlanguagecode: updatedEntry.parentlanguagecode,
                    languagecode: updatedEntry.languagecode
                  };
                }
              }
              return student;
            });
          });
        }
      } else {
        console.log("No matching student entry found for", studentIdentifier, "in class", classId);
      }
    } catch (err) {
      console.error("Error updating class studentIds:", err);
    }
  };

  const toggleGender = async () => {
    if (!currentstudent || !currentstudent.id) return;
    const newGender = currentstudent.gender === "he" ? "she" : "he";
    const updatedStudent = { ...currentstudent, gender: newGender };
    try {
      await updateDoc(doc(firebase, "users", currentstudent.id), {
        gender: newGender
      });

      setCurrentstudent(updatedStudent);

      if (Array.isArray(currentclass) && updatedStudent && updatedStudent.id) {
        const updatedClass = currentclass.map(student =>
          student.id === updatedStudent.id ? updatedStudent : student
        );
        setCurrentclass(updatedClass);
      }
    } catch (err) {
      console.error("Error toggling gender:", err);
      alert("Failed to update gender: " + err.message);
    }
  };

  return (
    <div className="inner123">
      {typeof currentclass != "undefined" && currentclass.length > 0 && (
        <>
          {typeof studentidd == "undefined" || studentidd == "" && currentclass.length > 0 ? (
            <div className="selectstudentmessage">
              (Current Roster)</div>) : null}

          {currentclass.map((item, index) => (
            <React.Fragment key={item.id || index}>
              {/* Show student list item if no student selected or this is the selected student and still animating */}
              {(typeof studentidd == "undefined" || studentidd == "" ||
                (selectedStudentAnimating && item.id == studentidd)) ? (
                <div
                  onClick={() => selectHandler(item, index)}
                  onMouseEnter={() => handleStudentHover(item.id)}
                  className={`${visibleStudents.includes(item.id) ? "student-visible" : "student-hidden"} 
                            ${item.id == studentidd && selectedStudentAnimating ? "student-selected-animating" : ""}`}
                >
                  <div
                    className={
                      item.id == studentidd ? "passstart2" : "passstart"
                    }
                  >
                    {item.localfirstname} {item.locallastname} {item.homeroom ? <span style={{ color: "yellow" }}>{item.homeroom}</span> : ""}
                    {Array.isArray(selectedStudents) && selectedStudents.includes(item.id) ? " ✅" : ""}<br></br>
                    {item.email}-{item.passwordactual}

                    <div></div>
                  </div>

                </div>

              ) : editparentcontactinfo == false && typeof studentidd != "undefined" &&
                item.id == studentidd && detailsVisible ? (
                <div className="student-details-visible">
                  <div onClick={() => selectHandler(item, index)}
                    className={
                      item.id == studentidd ? "passstart" : "passstart"
                    }
                  >
                    {item.localfirstname} {item.locallastname} {item.homeroom ? <span style={{ color: "yellow" }}>{item.homeroom}</span> : ""}<br></br>
                    {item.email}-{item.passwordactual}

                    <div></div>
                  </div>

                  <div style={{ display: "inline-flex", alignItems: "center" }}>
                    {/* Previous student arrow */}
                    <div
                      onClick={e => {
                        e.stopPropagation();
                        const currentIndex = currentclass.findIndex(student => student.id === item.id);
                        const prevIndex = (currentIndex - 1 + currentclass.length) % currentclass.length;
                        const prevStudent = currentclass[prevIndex];
                        setCurrentstudent(prevStudent);
                      }}
                      style={{
                        display: "inline-flex",
                        marginRight: "10px",
                        cursor: "pointer",
                        backgroundColor: "#013469",
                        color: "white",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "transform 0.2s, background-color 0.2s",
                        fontSize: "20px",
                        userSelect: "none"
                      }}
                      onMouseOver={e => e.currentTarget.style.transform = "scale(1.1)"}
                      onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                      title="Go to previous student"
                    >
                      &#8592;
                    </div>
                    {/* Next student arrow */}
                    <div
                      onClick={e => {
                        e.stopPropagation();
                        const currentIndex = currentclass.findIndex(student => student.id === item.id);
                        const nextIndex = (currentIndex + 1) % currentclass.length;
                        const nextStudent = currentclass[nextIndex];
                        setCurrentstudent(nextStudent);
                      }}
                      style={{
                        display: "inline-flex",
                        marginLeft: "10px",
                        cursor: "pointer",
                        backgroundColor: "#013469",
                        color: "white",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "transform 0.2s, background-color 0.2s",
                        fontSize: "20px",
                        userSelect: "none"
                      }}
                      onMouseOver={e => e.currentTarget.style.transform = "scale(1.1)"}
                      onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                      title="Go to next student"
                    >
                      &#8594;
                    </div>
                  </div>

                  <br></br>

                  <div className="passstart" onClick={() => makingpassbefore()}>
                    <div className="innertext">Send {currentstudent.localfirstname} on Pass</div>
                  </div>

                  <div className="passstart" onClick={() => setEditparentcontactinfo(true)}>
                    <div className="innertext">Show/Edit Contact Info.</div>
                  </div>

                  <div className="passstart">
                    <div
                      className="innertext"

                      onClick={() => window.open(website, '_blank', 'noopener,noreferrer')}  onMouseEnter={e => {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerHTML = `The part of the parent site that is editable is the "About" page. To edit it, select that page from the Navigation bar then select the Pencil that appears. When the pencil is selected you will be able to Add "bulletin" items to the "About" page by pressing the "+" sign in the bottom right corner.`;
                  tooltip.style.position = "absolute";
                  tooltip.style.top = "50%";
                  tooltip.style.left = "105%";
                  tooltip.style.transform = "translateY(-50%)";
                  tooltip.style.background = "#013469";
                  tooltip.style.color = "#fff";
                  tooltip.style.padding = "10px 16px";
                  tooltip.style.borderRadius = "8px";
                  tooltip.style.fontSize = "16px";
                  tooltip.style.zIndex = "1000";
                  tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                  tooltip.style.borderColor = "#E43522";
                  tooltip.style.borderWidth = "3px";
                  tooltip.style.borderStyle = "solid";
                  tooltip.style.pointerEvents = "none";
                  tooltip.style.width = "300px";
                  e.currentTarget.appendChild(tooltip);
                  e.currentTarget._tooltip = tooltip;
                }}
                onMouseLeave={e => {
                  if (e.currentTarget._tooltip) {
                    e.currentTarget.removeChild(e.currentTarget._tooltip);
                    e.currentTarget._tooltip = null;
                  }
                }}
                    >
                      (Editable) Site For Parents
                    </div>

                  </div>
                  <div className="passstart">
                    <div
                      className="innertext"

                      onClick={() => setShowParentPreviewModal(true)}
                      onMouseEnter={e => {
                  const tooltip = document.createElement("div");
                  tooltip.className = "custom-tooltip";
                  tooltip.innerHTML = `Teachers can optionally place a link to these sites at the bottom of messages to parents. Besides a 'home' page, this site contains a 'messaging' page which allows parents to adjust emails/phone numbers that they would like to get messages from OR unsubscribe. If the teacher selects for it, the site will show a 'Grades' page which will feature the chosen Google Classroom Assignment and a top ten list of grades from that assignment. Also, if the teacher adds entries to the 'About' page that page will show as well.`;
                  tooltip.style.position = "absolute";
                  tooltip.style.top = "50%";
                  tooltip.style.left = "105%";
                  tooltip.style.transform = "translateY(-50%)";
                  tooltip.style.background = "#013469";
                  tooltip.style.color = "#fff";
                  tooltip.style.padding = "10px 16px";
                  tooltip.style.borderRadius = "8px";
                  tooltip.style.fontSize = "16px";
                  tooltip.style.zIndex = "1000";
                  tooltip.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                  tooltip.style.borderColor = "#E43522";
                  tooltip.style.borderWidth = "3px";
                  tooltip.style.borderStyle = "solid";
                  tooltip.style.pointerEvents = "none";
                  tooltip.style.width = "300px";
                  e.currentTarget.appendChild(tooltip);
                  e.currentTarget._tooltip = tooltip;
                }}
                onMouseLeave={e => {
                  if (e.currentTarget._tooltip) {
                    e.currentTarget.removeChild(e.currentTarget._tooltip);
                    e.currentTarget._tooltip = null;
                  }
                }}
                    >
                      View Parents' Sites
                    </div>
                  </div>
                </div>
              ) : editparentcontactinfo == true && typeof studentidd != "undefined" && item.id == studentidd ? (<div style={{ top: 'var(--move-distance, -20px)', position: 'relative' }}>
                <div
                  className={
                    item.id == studentidd ? "passstart2" : "passstart"
                  }
                >
                  <div onClick={() => console.log("select")}>
                    {item.localfirstname} {item.locallastname}  {item.homeroom ? <span style={{ color: "yellow" }}>{item.homeroom}</span> : ""}<br></br>
                    {item.email}-{item.passwordactual}
                  </div>

                  <div></div>
                </div>

                <div style={{ display: "inline-flex", alignItems: "center" }}>
                  {/* Previous student arrow */}
                  <div
                    onClick={e => {
                      e.stopPropagation();
                       console.log("Arrow clicked, item.id:", item.id);
                      markParentContactConfirmed(item.id);

                      const currentIndex = currentclass.findIndex(student => student.id === item.id);
                      const prevIndex = (currentIndex - 1 + currentclass.length) % currentclass.length;
                      const prevStudent = currentclass[prevIndex];
                      setCurrentstudent(prevStudent);
                    }}
                    style={{
                      display: "inline-flex",
                      marginRight: "10px",
                      cursor: "pointer",
                      backgroundColor: "#013469",
                      color: "white",
                      borderRadius: "50%",
                      width: "30px",
                      height: "30px",
                      justifyContent: "center",
                      alignItems: "center",
                      transition: "transform 0.2s, background-color 0.2s",
                      fontSize: "20px",
                      userSelect: "none"
                    }}
                    onMouseOver={e => e.currentTarget.style.transform = "scale(1.1)"}
                    onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                    title="Go to previous student"
                  >
                    &#8592;
                  </div>
                  {/* Next student arrow */}
                  <div
                    onClick={e => {
                      e.stopPropagation();
                      markParentContactConfirmed(item.id);
                      const currentIndex = currentclass.findIndex(student => student.id === item.id);
                      const nextIndex = (currentIndex + 1) % currentclass.length;
                      const nextStudent = currentclass[nextIndex];
                      setCurrentstudent(nextStudent);
                    }}
                    style={{
                      display: "inline-flex",
                      marginLeft: "10px",
                      cursor: "pointer",
                      backgroundColor: "#013469",
                      color: "white",
                      borderRadius: "50%",
                      width: "30px",
                      height: "30px",
                      justifyContent: "center",
                      alignItems: "center",
                      transition: "transform 0.2s, background-color 0.2s",
                      fontSize: "20px",
                      userSelect: "none"
                    }}
                    onMouseOver={e => e.currentTarget.style.transform = "scale(1.1)"}
                    onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                    title="Go to next student"
                  >
                    &#8594;
                  </div>
                </div>

                <br></br>
                {phonenumberbefore2.length == 10 ||
                  (parentemail.includes('@') && parentemail.includes('.'))
                  ?
                  <div className="passstart" onClick={() => setSaveparentcontactinfo(item)}>
                    <div className="innertext">Save Added Info.</div>
                  </div> : <div className="passstart" onClick={() => setEditparentcontactinfo(false)}>
                    <div className="innertext">Close Contact Info.</div>
                  </div>}
                <input
                  className="Newrow2998"
                  placeholder={"Enter Parent's Phone Number"}
                  type="text"
                  value={phonenumberbefore2}
                  onChange={(e) => onChanged2(e.target.value)}
                  onPaste={handlePaste2}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && phonenumberbefore2.length === 10) {
                      setSaveparentcontactinfo(item);
                    }
                  }}
                />
                {Array.isArray(currentstudent?.parentphonenumber) && currentstudent.parentphonenumber.length > 0 ? (
                  <div className="parent-phone-list">
                    <div style={{ margin: 0, paddingLeft: 18, listStyleType: "none" }}>
                      <ul style={{ listStyleType: "none", paddingLeft: 0, margin: 0 }}>
                        {currentstudent.parentphonenumber.map((phone, idx) =>
                          phone && phone.length > 0 ? (
                            <li key={idx} style={{ listStyleType: "none" }}>
                              {phone}
                              <button
                                style={{
                                  margin: 6,
                                  marginLeft: "10px",
                                  background: "none",
                                  border: "none",
                                  color: "#e43522",
                                  cursor: "pointer"
                                }}
                                title="Delete phone number"
                                onClick={() => deletethisphonenumber(phone)}
                              >
                                ❌
                              </button>
                            </li>
                          ) : null
                        )}
                      </ul>
                    </div>
                  </div>
                ) : Array.isArray(currentstudent?.parentphonenumber) && (
                  <div className="parent-phone-list">
                    <div style={{ margin: 0, paddingLeft: 18, color: "#666", fontStyle: "italic" }}>
                      Unsubscribed from Texts
                    </div>
                  </div>
                )}

                <input
                  className="Newrow2998"
                  placeholder={"Enter Parent's Email"}
                  value={parentemail}
                  onChange={(e) => setParentemail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && parentemail.includes('@') && parentemail.includes('.')) {
                      setSaveparentcontactinfo(item);
                    }
                  }}
                />


                {Array.isArray(currentstudent?.parentemail) && currentstudent.parentemail.length > 0 ? (
                  <div className="parent-phone-list">
                    <div style={{ margin: 0, paddingLeft: 18, listStyleType: "none" }}>
                      <ul style={{ listStyleType: "none", paddingLeft: 0, margin: 0 }}>
                        {[...new Set(currentstudent.parentemail)].map((email, idx) =>
                          email && email.includes('@') && email.includes('.') ? (
                            <li key={idx} style={{ listStyleType: "none" }}>
                              {email}
                              <button
                                style={{
                                  margin: 6,
                                  marginLeft: "10px",
                                  background: "none",
                                  border: "none",
                                  color: "#e43522",
                                  cursor: "pointer"
                                }}
                                title="Delete email"
                                onClick={() => deletethisemail(email)}
                              >
                                ❌
                              </button>
                            </li>
                          ) : null
                        )}
                      </ul>
                    </div>
                  </div>
                ) : Array.isArray(currentstudent?.parentemail) && (
                  <div className="parent-phone-list">
                    <div style={{ margin: 0, paddingLeft: 18, color: "#666", fontStyle: "italic" }}>
                      Unsubscribed from Emails
                    </div>
                  </div>
                )}
                <br></br>
                {currentstudent?.gender === "he" ? (
                  <div className="passstart" onClick={() => toggleGender()}>
                    <div className="innertext">For messaging - Identified as 'Male'</div>
                  </div>
                ) : (
                  <div className="passstart" onClick={() => toggleGender()}>
                    <div className="innertext">For messaging - Identified as 'Female'</div>
                  </div>
                )}
                <br></br>
                <div style={{
                  backgroundColor: "#000",
                  color: "#fff",
                  maxWidth: "500px",
                  margin: "0 auto"
                }}>
                  {/* Search input */}
                  <input
                    className="Newrow2998"
                    placeholder="Search Languages"
                    onChange={(e) => setNewparentlanguage(e.target.value)}
                    value={newparentlanguage}
                  />

                  {/* Current language display */}
                  <div style={{
                    textAlign: "center",
                    backgroundColor: "#000000",
                    color: "#fff",
                  }}>
                    <span>Current Parent Language: {currentstudent.parentlanguage}</span>
                  </div>

                  <div style={{ marginTop: "20px" }}></div>

                  {/* Language options list */}
                  <div style={{
                    height: "110px",
                    overflowY: "scroll",
                    padding: "10px",
                    marginTop: "10px"
                  }}>
                    {filteredstates.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          alignItems: "center",
                          padding: "5px 0",
                          cursor: "pointer",
                          backgroundColor: "#013469",
                          borderRadius: "50px",
                          marginBottom: "4px",
                        }}
                        onClick={() => handleSelect(item)}
                      >
                        <span style={{ color: "white" }}>{item.value}</span>
                      </div>
                    ))}
                  </div>
                </div>




                 <br></br>
                <div style={{
                  backgroundColor: "#000",
                  color: "#fff",
                  maxWidth: "500px",
                  margin: "0 auto"
                }}>
                  {/* Search input */}
                  <input
                    className="Newrow2998"
                    placeholder="Search Languages"
                    onChange={(e) => setNewstudentlanguage(e.target.value)}
                    value={newstudentlanguage}
                  />

                  {/* Current language display */}
                  <div style={{
                    textAlign: "center",
                    backgroundColor: "#000000",
                    color: "#fff",
                  }}>
                    <span>Current Student Language: {currentstudent.language ? currentstudent.language : "English"}</span>
                  </div>

                  <div style={{ marginTop: "20px" }}></div>

                  {/* Language options list */}
                  <div style={{
                    height: "110px",
                    overflowY: "scroll",
                    padding: "10px",
                    marginTop: "10px"
                  }}>
                    {filteredstates2.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          alignItems: "center",
                          padding: "5px 0",
                          cursor: "pointer",
                          backgroundColor: "#013469",
                          borderRadius: "50px",
                          marginBottom: "4px",
                        }}
                        onClick={() => handleStudentLanguageSelect(item)}
                      >
                        <span style={{ color: "white" }}>{item.value}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Gender toggle button */}

                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              </div>
              ) : null}
            </React.Fragment>
          ))}
        </>
      )}
      <br></br>

      {showParentPreviewModal && whatparentssee ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
          onClick={() => setShowParentPreviewModal(false)}
        >
          <div
            style={{
              position: "relative",
              width: "96vw",
              height: "92vh",
              background: "#000",
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
              border: "2px solid #013469",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowParentPreviewModal(false)}
              style={{
                position: "absolute",
                top: 14,
                right: 14,
                zIndex: 3,
                background: "rgba(0,0,0,0.75)",
                color: "#fff",
                border: "2px solid #e43522",
                borderRadius: "999px",
                width: "42px",
                height: "42px",
                cursor: "pointer",
                fontSize: "20px",
              }}
              title="Close preview"
            >
              ×
            </button>

            <div
              onClick={(e) => {
                e.stopPropagation();
                goToAdjacentStudent("previous");
              }}
              style={{
                position: "absolute",
                top: "50%",
                left: "18px",
                transform: "translateY(-50%)",
                zIndex: 3,
                display: "inline-flex",
                cursor: "pointer",
                backgroundColor: "#013469",
                color: "white",
                borderRadius: "50%",
                width: "44px",
                height: "44px",
                justifyContent: "center",
                alignItems: "center",
                transition: "transform 0.2s, background-color 0.2s",
                fontSize: "26px",
                userSelect: "none",
                border: "2px solid #e43522",
              }}
              onMouseOver={e => e.currentTarget.style.transform = "translateY(-50%) scale(1.1)"}
              onMouseOut={e => e.currentTarget.style.transform = "translateY(-50%) scale(1)"}
              title="Go to previous student"
            >
              &#8592;
            </div>

            <div
              onClick={(e) => {
                e.stopPropagation();
                goToAdjacentStudent("next");
              }}
              style={{
                position: "absolute",
                top: "50%",
                right: "18px",
                transform: "translateY(-50%)",
                zIndex: 3,
                display: "inline-flex",
                cursor: "pointer",
                backgroundColor: "#013469",
                color: "white",
                borderRadius: "50%",
                width: "44px",
                height: "44px",
                justifyContent: "center",
                alignItems: "center",
                transition: "transform 0.2s, background-color 0.2s",
                fontSize: "26px",
                userSelect: "none",
                border: "2px solid #e43522",
              }}
              onMouseOver={e => e.currentTarget.style.transform = "translateY(-50%) scale(1.1)"}
              onMouseOut={e => e.currentTarget.style.transform = "translateY(-50%) scale(1)"}
              title="Go to next student"
            >
              &#8594;
            </div>

            <div
              style={{
                position: "absolute",
                top: 14,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 3,
                background: "rgba(0,0,0,0.75)",
                color: "#fff",
                padding: "10px 18px",
                borderRadius: "999px",
                border: "1px solid rgba(255,255,255,0.2)",
                fontSize: "16px",
                maxWidth: "70vw",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {currentstudent?.localfirstname || ""} {currentstudent?.locallastname || ""} Parent Preview
            </div>

            <iframe
              key={whatparentssee}
              src={whatparentssee}
              title="Parent Preview"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                background: "#fff",
              }}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}

/* <View>
<div
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onClick={() => selectHandler(item)}>
  <div style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</div>
</div>


</View> */
